import React, { useState } from 'react';
import { colorSet, clsx } from '@components/Provider';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';
import { routes } from './ProfileMenuInfo';
import {
  List,
  ListItem,
  ListItemText,
  Divider,
  Popper,
  Box,
  makeStyles,
  Avatar,
  ClickAwayListener,
  IconButton,
  ListItemIcon
} from '@material-ui/core';
import { Cached } from '@material-ui/icons';
import { CapaServiceType } from '@generated/graphql';

const useStyles = makeStyles({
  root: {
    zIndex: 2000,
    top: '61px !important',
    right: '32px !important',
    left: 'initial !important',
    transform: 'initial !important'
  },
  boxRoot: {
    width: 226,
    height: '100%',
    borderRadius: 4,
    backgroundColor: colorSet.gray000,
    padding: '8px 12px',
    boxShadow:
      '0px 8px 16px 2px rgba(97, 97, 97, 0.1), 0px 16px 32px 2px rgba(97, 97, 97, 0.1)'
  },
  title: {
    padding: '12px 8px 16px 8px',
    '& .MuiTypography-root': {
      wordBreak: 'break-all'
    }
  },
  list: {
    padding: 0
  },
  listItem: {
    padding: '10px 8px',
    borderRadius: 4,
    height: 40,
    '&.goto-client-btn': {
      padding: '30px 8px'
    },
    '&.logout-btn': {
      textAlign: 'center',
      '& .MuiTypography-body2': {
        width: '100%'
      }
    }
  },
  menuIcon: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    width: 32,
    height: 32,
    '& .MuiAvatar-circular': {
      width: 26.67,
      height: 26.67,
      color: colorSet.gray000,
      '&.MuiAvatar-colorDefault': {
        backgroundColor: 'transparent',
        '& img': {
          width: '100%',
          height: '100%'
        }
      }
    }
  },
  divider: {
    backgroundColor: colorSet.gray200,
    margin: '10px 8px'
  }
});

interface Props {
  managerName?: string;
  profileLogoImgSrc?: string;
  handleSwitchService: (service: CapaServiceType) => Promise<string | void>;
  onClickHandle: (value: string) => void;
  handleLogout: () => void;
}

const GnbPopupMenuPresenter: React.FC<Props> = ({
  managerName,
  profileLogoImgSrc,
  handleSwitchService,
  onClickHandle,
  handleLogout
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const onClose = () => setOpen(false);

  return (
    <React.Fragment>
      <ClickAwayListener onClickAway={onClose}>
        <IconButton
          className={clsx(classes.menuIcon, 'gnb-popup-menu')}
          onClick={(e) => {
            if (e.currentTarget) {
              setAnchorEl(e.currentTarget);
              setOpen((prevOpen) => !prevOpen);
            }
          }}
        >
          <Avatar alt="profile" src={profileLogoImgSrc} />
        </IconButton>
      </ClickAwayListener>
      <Popper
        className={classes.root}
        open={open}
        anchorEl={anchorEl}
        transition
        disablePortal
        placement="bottom-end"
      >
        <Box className={classes.boxRoot}>
          <div className={classes.title}>
            <CustomizedTypography variant="body1" fontWeight="500">
              안녕하세요, {managerName}님
            </CustomizedTypography>
          </div>
          <List className={classes.list}>
            {routes.map((item, index) => {
              return (
                <ListItem
                  key={index}
                  className={classes.listItem}
                  button
                  onClick={() => {
                    onClose();
                    onClickHandle(item.url);
                  }}
                >
                  <ListItemIcon>{item.logo}</ListItemIcon>
                  <ListItemText
                    primary={item.menu}
                    primaryTypographyProps={{ variant: 'body2' }}
                  />
                </ListItem>
              );
            })}
          </List>
          <Divider className={classes.divider} />
          <ListItem className={clsx(classes.listItem, 'goto-client-btn')}>
            <CustomizedButton
              variant="outlined"
              size="medium"
              color="primary"
              startIcon={<Cached fontSize="small" />}
              fullWidth
              onClick={async () => {
                await handleSwitchService(CapaServiceType.QuotationPartner);
                onClose();
              }}
            >
              파트너로 전환
            </CustomizedButton>
          </ListItem>
          <Divider className={classes.divider} />
          <ListItem
            className={clsx(classes.listItem, 'logout-btn')}
            button
            onClick={handleLogout}
          >
            <CustomizedTypography
              variant="body2"
              fontWeight="500"
              align="center"
              color="textSecondary"
            >
              로그아웃
            </CustomizedTypography>
          </ListItem>
        </Box>
      </Popper>
    </React.Fragment>
  );
};

export default GnbPopupMenuPresenter;
